import { createAction, props } from '@ngrx/store';

export const setprojectDetailsPONumber = createAction('[CurrentprojectDetailsPONumber] Set projectDetailsPONumber', props<{ projectDetailsPONumber: any }>());
export const clearprojectDetailsPONumber = createAction('[CurrentprojectDetailsPONumber] Clear projectDetailsPONumber');
